import { spacingTokens } from '../theme/spacing';
const BASE_UNIT = 4;
export const DEFAULT_PIXEL_SIZE = 16;
/**
 * takes a pixel value (number) and returns a string in rem
 * @example unit(16) => '1rem'
 */
export function pxToRem(px) {
    return `${px / DEFAULT_PIXEL_SIZE}rem`;
}
/**
 * @deprecated Use `themeGet('spacing.{spacingVariable}')` instead. Example: `themeGet('spacing.small')`
 */
export function spacing(value) {
    if (typeof value === 'number') {
        return pxToRem(value * BASE_UNIT);
    }
    const spacingValue = spacingTokens[value];
    return spacingValue || value;
}
/**
 * @deprecated Use pxToRem instead
 */
export const unit = spacing;
/**
 * @deprecated Use `themeGet('spacing.{spacingVariable}')` or pxToRem(number) instead. Example: `themeGet('spacing.small')` or pxToRem(15)
 */
export const padding = (...args) => `padding: ${args.map((multiple) => unit(multiple)).join(' ')};`;
/**
 * @deprecated Use `themeGet('spacing.{spacingVariable}')` or pxToRem(number) instead. Example: `themeGet('spacing.small')` or pxToRem(15)
 */
export const paddingTop = (multiple) => `padding-top: ${unit(multiple)}`;
/**
 * @deprecated Use `themeGet('spacing.{spacingVariable}')` or pxToRem(number) instead. Example: `themeGet('spacing.small')` or pxToRem(15)
 */
export const paddingRight = (multiple) => `padding-right: ${unit(multiple)}`;
/**
 * @deprecated Use `themeGet('spacing.{spacingVariable}')` or pxToRem(number) instead. Example: `themeGet('spacing.small')` or pxToRem(15)
 */
export const paddingBottom = (multiple) => `padding-bottom: ${unit(multiple)}`;
/**
 * @deprecated Use `themeGet('spacing.{spacingVariable}')` or pxToRem(number) instead. Example: `themeGet('spacing.small')` or pxToRem(15)
 */
export const paddingLeft = (multiple) => `padding-left: ${unit(multiple)}`;
/**
 * @deprecated Use `themeGet('spacing.{spacingVariable}')` or pxToRem(number) instead. Example: `themeGet('spacing.small')` or pxToRem(15)
 */
export const margin = (...args) => `margin: ${args.map((multiple) => unit(multiple)).join(' ')};`;
/**
 * @deprecated Use `themeGet('spacing.{spacingVariable}')` or pxToRem(number) instead. Example: `themeGet('spacing.small')` or pxToRem(15)
 */
export const marginTop = (multiple) => `margin-top: ${unit(multiple)}`;
/**
 * @deprecated Use `themeGet('spacing.{spacingVariable}')` or pxToRem(number) instead. Example: `themeGet('spacing.small')` or pxToRem(15)
 */
export const marginRight = (multiple) => `margin-right: ${unit(multiple)}`;
/**
 * @deprecated Use `themeGet('spacing.{spacingVariable}')` or pxToRem(number) instead. Example: `themeGet('spacing.small')` or pxToRem(15)
 */
export const marginBottom = (multiple) => `margin-bottom: ${unit(multiple)}`;
/**
 * @deprecated Use `themeGet('spacing.{spacingVariable}')` or pxToRem(number) instead. Example: `themeGet('spacing.small')` or pxToRem(15)
 */
export const marginLeft = (multiple) => `margin-left: ${unit(multiple)}`;
